class App {
  constructor() {
    this.isLaunched = false
    this.availableApps = []
    this.preDefinedApps = {
      BLUETOOTH: null,
      USB: null,
      MIRACAST: null,
      AIRPLAY: null,
      CHROMECAST: null,
      YOUTUBE: null,
      NETFLIX: null,
      PRIME: null,
      BROWSER: null
    }
  }
  async _init() {
    await this.syncAppList()
    this._updateApps()

    _$.vue.$on("applicationFocusing", () => __.platform.focusing())
    _$.vue.$on("applicationUnfocused", () => __.platform.unfocusing())

    return true
  }
  async launch(app_id, param = false, instant = false) {
    if (!__.platform.focus) return false

    if (!app_id) return false
    let application = app_id.toString()

    if (!instant) {
      application = this._findApp(application)
      if (!application && app_id === "chromecast") return __.platform.go("chromecast")
      else if (!application) return false
    }

    const res = await __._app.launch(typeof application === "object" ? application.key : application, param).catch(err => _$.error(err))
    if (res) this.isLaunched = application.key

    return res
  }
  async close() {
    if (__.platform.focus) return false

    return __._app
      .close()
      .catch(err => _$.error(err))
      .finally(() => (this.isLaunched = false))
  }
  async select(title, apps) {
    if (!title) return false

    apps = this._getList(apps)
    if (!apps) return false

    const res = await _$.vue.$sidepane(title, null, apps)
    if (!res) return false

    return this.launch(res, null, true)
  }

  _getList(request = false) {
    try {
      if (!request) return this.availableApps

      let apps = []

      if (typeof request === "string") request = request.split(",")
      if (!Array.isArray(request)) return false

      request.map(app => {
        const res = this._findApp(app)
        if (res) apps.push(res)
      })

      if (!apps.length) return false

      return apps
    } catch (err) {
      return _$.error(err)
    }
  }
  _findApp(app_id) {
    try {
      if (!app_id) return false
      app_id = app_id.toString().toUpperCase()
      if (this.preDefinedApps[app_id]) {
        app_id = this.preDefinedApps[app_id]
        app_id = app_id.toString().toUpperCase()
      }

      let application = this.availableApps.find(app => {
        if (app.key && app.key.toString().toUpperCase() === app_id) return true
        else if (app.value && app.value.toString().toUpperCase() === app_id) return true
        else return false
      })

      if (!application && typeof app_id === "string")
        application = this.availableApps.find(
          app =>
            app.value &&
            app.value
              .toString()
              .toUpperCase()
              .includes(app_id)
        )

      return application
    } catch (err) {
      return _$.error(err)
    }
  }
  _updateApps() {
    Object.assign(this.preDefinedApps, __._app.preDefinedApps)
    Object.keys(this.preDefinedApps).forEach(key => {
      if (!this.preDefinedApps[key]) delete this.preDefinedApps[key]
    })
  }
  async syncAppList() {
    this.availableApps = await __._app.getList()
    if (!this.availableApps) this.availableApps = []
  }
}

export default new App()
